import { Feature, Point } from "geojson";
import MapboxGl, { EventData, MapLayerMouseEvent } from "mapbox-gl";

import * as Mapbox from "~/Dashboard/MapBox";

export const mapPopup = (
  map: MapboxGl.Map,
  popup: MapboxGl.Popup,
  layerName: string,
  popupFunctionality: (
    map: MapboxGl.Map,
    popup: MapboxGl.Popup,
    feature: Feature,
    coordinates: readonly [number, number]
  ) => void
) => {
  map.on("mouseenter", layerName, (e: MapLayerMouseEvent & EventData) => {
    // Change the cursor style as a UI indicator.
    // eslint-disable-next-line functional/immutable-data,functional/no-expression-statement
    map.getCanvas().style.cursor = "pointer";

    if (e && e.features && e.features.length > 0) {
      const feature = e.features[0];

      const coordinates = (feature.geometry as Point).coordinates.slice();

      // eslint-disable-next-line functional/no-let
      let coordinate = coordinates[0];

      // Ensure that if the map is zoomed out such that multiple
      // copies of the feature are visible, the popup appears
      // over the copy being pointed to.
      // eslint-disable-next-line functional/no-loop-statement
      while (Math.abs(e.lngLat.lng - coordinate) > 180) {
        // eslint-disable-next-line functional/no-expression-statement
        coordinate += e.lngLat.lng > coordinate ? 360 : -360;
      }

      // eslint-disable-next-line functional/no-expression-statement
      popupFunctionality(map, popup, feature, [coordinate, coordinates[1]]);
    }
  });

  map.on("mouseleave", layerName, function () {
    // eslint-disable-next-line functional/immutable-data,functional/no-expression-statement
    map.getCanvas().style.cursor = "";
    // eslint-disable-next-line functional/no-expression-statement
    popup.remove();
  });
};

export const driverPopupHandler = (
  map: MapboxGl.Map,
  popup: MapboxGl.Popup,
  feature: Feature,
  coordinates: readonly [number, number]
) => {
  const featureProperties = feature.properties as Mapbox.FeatureProperties;
  const driverName = featureProperties.name;
  const popupHtml = `
                <div class="driver-popup">
                  <span>
                      <strong>${driverName}</strong>
                  </span>
                  <hr/>
                  <p>App Version: ${featureProperties.appVersion}</p>
                  <p>
                    <div>OS Type: ${featureProperties.osType}</div>
                    <div>Version: ${featureProperties.osVersion}</div>
                  </p>
                </div>
              `;

  // Populate the popup and set its coordinates
  // based on the feature found.
  // eslint-disable-next-line functional/no-expression-statement
  popup
    .setLngLat([...coordinates])
    .setHTML(popupHtml)
    .addTo(map);
};

export const clusterPopupHandler = (
  map: MapboxGl.Map,
  popup: MapboxGl.Popup,
  feature: Feature,
  coordinates: readonly [number, number]
) => {
  // eslint-disable-next-line functional/no-expression-statement
  popup
    .setLngLat([...coordinates])
    .setHTML(`<svg class="cluster-chart"></svg>`)
    .addTo(map);

  const featureProperties = feature.properties as Mapbox.CountProperties & {
    readonly point_count: number;
  };

  // eslint-disable-next-line functional/no-expression-statement
  Mapbox.ClusterChart.generateChart(
    [feature],
    featureProperties.point_count,
    "cluster-chart"
  );
};
